// extracted by mini-css-extract-plugin
module.exports = {"navbarRight":"navbar-module--navbarRight--3Mv9S","hexagon":"navbar-module--hexagon--1Oua7"};